import { FC } from 'react'
import './index.less'
import { TextAppearance, FontSize, Colors, Display } from '../../util/types'
import { PerSpacerProps } from '../Spacer'
import { marginClasses } from '../../util/less-util'
import { Tooltip } from 'antd'
import { LinkToProfile } from '../AvatarPlus'

export interface PerTextProps extends PerSpacerProps {
  truncated?: boolean
  appearance?: TextAppearance
  fontSize?: FontSize
  fontWeight?: 'thin' | 'normal' | 'bold'
  fontFamily?: 'normal' | 'mono'
  color?: Colors
  transform?: 'uppercase' | 'lowercase' | 'capitalize'
  align?: 'left' | 'right' | 'center'
  wordBreak?: boolean
  display?: Display
  strikeThrough?: boolean
  className?: string
  testId?: string
  tooltip?: string
  linkToProfile?: LinkToProfile
  linkToProfileSearch?: boolean
}

const PerText: FC<PerTextProps> = ({
  truncated,
  children,
  appearance,
  fontSize,
  fontWeight,
  fontFamily,
  color,
  transform,
  align,
  wordBreak = false,
  display,
  strikeThrough,
  className,
  testId,
  tooltip,
  linkToProfile,
  linkToProfileSearch,
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml,
}) => {
  const text = 'per-text'
  const modifiers = marginClasses(m, mb, mt, ml, mr, mx, my, 'per-spacer')

  if (appearance) {
    modifiers.push(`${text}--${appearance}`)
  }

  if (fontSize) {
    modifiers.push(`${text}--font-size-${fontSize}`)
  }

  if (fontWeight) {
    modifiers.push(`${text}--font-weight-${fontWeight}`)
  }

  if (fontFamily) {
    modifiers.push(`${text}--font-family-${fontFamily}`)
  }

  if (color) {
    modifiers.push(`${text}--color-${color}`)
  }

  if (align) {
    modifiers.push(`${text}--align-${align}`)
  }

  if (transform) {
    modifiers.push(`${text}--transform-${transform}`)
  }

  if (display) {
    modifiers.push(`${text}--display-${display}`)
  }

  if (strikeThrough) {
    modifiers.push(`${text}--strike-through`)
  }

  if (className) {
    modifiers.push(className)
  }

  if (wordBreak) {
    modifiers.push('word-break')
  }

  if (linkToProfile) {
    modifiers.push(`${text}--hoverable`)
  } else if (linkToProfileSearch) {
    modifiers.push(`${text}--hoverable-search`)
  }

  return !!tooltip ? (
    <Tooltip title={tooltip}>
      <div className={text + ' ' + modifiers.join(' ')} data-testid={testId}>
        {children}
      </div>
    </Tooltip>
  ) : (
    <div
      className={text + ' ' + modifiers.join(' ')}
      data-testid={testId}
      style={!!truncated ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } : undefined}
    >
      {children}
    </div>
  )
}

export default PerText
